import { TranslationMap } from '@trimble-gcs/i18n-types';

export function scandataTableTranslations() {
  return {
    columns: {
      name: {
        text: $localize`:@@scandataTable.columns.name:Name`,
        desc: 'The "Name" column header in a table.',
      },
      status: {
        text: $localize`:@@scandataTable.columns.status:Status`,
        desc: 'The "Status" column header in a table.',
      },
      uploadedBy: {
        text: $localize`:@@scandataTable.columns.uploadedBy:Uploaded By`,
        desc: 'The "Uploaded By" column header in a table.',
      },
      uploadedDate: {
        text: $localize`:@@scandataTable.columns.uploadedDate:Upload Date`,
        desc: 'The "Upload Date" column header in a table.',
      },
      captureDate: {
        text: $localize`:@@scandataTable.columns.captureDate:Capture Date`,
        desc: 'The "Capture Date" column header in a table.',
      },
      pointCount: {
        text: $localize`:@@scandataTable.columns.pointCount:Points`,
        desc: 'The "Points" column header in a table. Represents a count of points.',
      },
      fileSize: {
        text: $localize`:@@scandataTable.columns.fileSize:Size`,
        desc: 'The "Size" column header in a table. Represents a file size.',
      },
      tags: {
        text: $localize`:@@scandataTable.columns.tags:Tags`,
        desc: 'The "Tags" column header in a table.',
      },
    },
    pointcloudStatus: {
      uploading: {
        text: $localize`:@@scandataTable.pointcloudStatus.uploading:Uploading`,
        desc: 'The icon tooltip for pointclouds that are busy uploading.',
      },
      processing: {
        text: $localize`:@@scandataTable.pointcloudStatus.processing:Processing`,
        desc: 'The icon tooltip for pointclouds that are busy processing.',
      },
      ready: {
        text: $localize`:@@scandataTable.pointcloudStatus.ready:Ready`,
        desc: 'The icon tooltip for pointclouds that have been processed and are ready to view.',
      },

      failed: {
        text: $localize`:@@scandataTable.pointcloudStatus.failed:Failed`,
        desc: 'The icon tooltip for pointclouds that failed processing.',
      },
    },
  } satisfies TranslationMap;
}
